import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Shared conversion band. `service` deep-links the quiz/booking to a visa.
export default function CtaBand({
  heading = "Not sure where to start?",
  body = "Tell us about your situation. We get your file application-ready and match you with a registered migration agent for the advice and lodgement, and we stay on it the whole way. No obligation.",
  service,
}) {
  const quizTo = service
    ? `/eligibility-quiz/?service=${service}`
    : "/eligibility-quiz/";
  const bookTo = service
    ? `/book-consultation/?service=${service}`
    : "/book-consultation/";
  return (
    <section className="py-16">
      <div className="container-page">
        <div className="flex flex-col items-center gap-6 rounded-3xl bg-acNavyDeep px-8 py-12 text-center md:flex-row md:text-left">
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-white sm:text-3xl">
              {heading}
            </h2>
            <p className="mt-3 text-white/70">{body}</p>
          </div>
          <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
            <Link to={quizTo} className="btn-on-dark">
              Check eligibility
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to={bookTo}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:border-acGold hover:text-acGold"
            >
              Book a consultation
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
